module.exports = __webpack_public_path__ + "img/99.10.7063c340.png";